<template>
  <div class="fast-collect-config-container" v-loading="loading">
    <div class="fast-collect-config-back">
      <el-button @click="goBack" type="primary" size="mini"><jee-icon iconClass="fanhui"></jee-icon> 返回</el-button>
    </div>
    <div class="fast-collect-config-box">
      <h2>快速采集</h2>
      <div class="fast-collect-config-form">
        <el-form ref="form" :rules="rules" :model="form" label-width="150px">
          <el-form-item label="任务名称：" prop="name">
            <el-input v-model="form.name" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item :label="FormName" prop="keyword" v-if="CollectDetail['type'] != 'gov'">
            <el-input v-model="form.keyword" maxlength="50"></el-input>
            <p class="fast-collect-config-form-tip" v-if="CollectDetail['type'] == 'weibo'">打开手机版微博，点击用户的微博主页，查看网址为：https://m.weibo.cn/u/2927573465， 后面的“2927573465”为该用户的UID。</p>
            <p class="fast-collect-config-form-tip" v-if="CollectDetail['type'] == 'baidu'">输入要搜索的关键字，比如“jeecms”。</p>
          </el-form-item>
          <el-form-item label="选择采集字段：" prop="fieldIds" class="fast-collect-config-form-checkbox">
            <el-checkbox-group v-model="form.fieldIds">
              <el-checkbox :key="index" v-for="(item, index) in CollectDetail.tableTile" :label="item.fieldIds" name="fieldIds" :disabled="item.fieldIds == 1">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="选择栏目：" prop="channelId">
            <el-tree
              ref="collectTree"
              :data="ChannelList"
              :props="defaultProps"
              highlight-current
              node-key="id"
              :default-expanded-keys="defaulCheckedKeys"
              accordion
              v-loading="channelLoading"
              @node-click="handleNodeClick"></el-tree>
          </el-form-item>
          <el-form-item label="选择内容模型：" prop="modelId">
            <el-select style="width: 100%" v-model="form.modelId" placeholder="请选择">
              <el-option
                v-for="item in ModelOptions"
                :key="item.id"
                :label="item.modelName"
                v-bind:value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-if="collectType === 'add'" @click="playCollect">开始采集</el-button>
            <el-button type="primary" v-if="collectType === 'edit'"  @click="startCollectTasks">开始采集</el-button>
            <el-button type="primary" v-if="collectType === 'add'" @click="save">仅保存任务</el-button>
            <el-button type="primary" v-if="collectType === 'edit'" @click="edit">仅保存任务</el-button>
            <el-button @click="goBack">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import FastCollectData from './FastCollectData'
import { deepClone, getTreeIds } from '@/utils'
export default {
  name: 'FastCollectConfig',
  data () {
    let validateKeyword = (rule, value, callback) => {
      if (this.CollectDetail['type'] !== 'gov') {
        if (value === '') {
          let text = '请输入关键字'
          if (this.CollectDetail['type'] === 'weibo') {
            text = '请输入用户UID'
          }
          callback(new Error(text))
        } else {
          callback()
        }
      }
    }

    return {
      CollectDetail: {}, // 快速采集详情
      form: {
        name: '', // 任务名称
        keyword: '', // 关键字 or 微博 uuid
        fieldIds: [], // 采集字段
        channelId: '', // 栏目
        modelId: '' // 内容模型
      },
      channelModels: {}, // 栏目与内容模型级联关系
      ChannelList: [], // 栏目选项
      ModelOptions: [], // 内容模型选项
      id: '', // 云端ID
      appid: '', // 客户端
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 表单验证
      rules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        keyword: [
          { required: true, validator: validateKeyword, trigger: 'blur' }
        ],
        channelId: [
          { required: true, message: '请选择栏目', trigger: 'change' }
        ],
        modelId: [
          { required: true, message: '请选择内容模型', trigger: 'change' }
        ]
      },
      loading: false, // 保存、开始采集loading
      channelLoading: true, // 栏目 loading
      defaulCheckedKeys: [], // 设置默认打开的栏目
      collectType: 'add' // 采集类型
    }
  },
  computed: {
    FormName () {
      let _this = this
      let text = '搜索关键字'
      if (_this.CollectDetail['type'] === 'weibo') {
        text = '用户UID'
      }
      return text
    }
  },
  watch: {
    'form': function () {
      let that = this
      if (this.collectType === 'edit') {
        setTimeout(function () {
          that.defaulCheckedKeys.push(that.form.channelId)
          that.$refs.collectTree.setCurrentKey(that.form.channelId)
        }, 100)
      }
    }
  },
  mounted () {
    let _this = this
    // 初始化，判断快速采集模板类型
    if (_this.$route.query.type !== undefined) {
      _this.CollectDetail = deepClone(FastCollectData[this.getIndex(_this.$route.query.type)])
      _this.form.name = _this.CollectDetail.title
    }
    this.id = window.localStorage.getItem('identity')
    this.appid = window.localStorage.getItem('appId')
    // 修改
    // this.id = '899601769511387296'
    // this.appid = '3aYBO*3bzQ5g3bAk5f3YMk9g'
    
    // 判断是否有 taskId, 如果有请求接口获取详情，如果没有初始化配置页面
    if (this.$route.query.taskId !== undefined) {
      this.collectType = 'edit'
      this.getCollectDetail(this.$route.query.taskId)
    } else {
      this.initConfing()
    }
    setTimeout(() => {
      _this.getCmsData()
    }, 150);
  },
  methods: {
    goBack () {
      if(this.collectType === 'edit') {
        window.history.back()
      }else {
        this.$router.go(-1)
      }
    },
    getIndex (type) {
      let FastCollectIndex = FastCollectData.findIndex((item, index) => {
        return item.modelType === Number(type)
      })
      return FastCollectIndex
    },
    // 获取采集任务详情
    getCollectDetail (id) {
      this.$request.fetchCollectTaskDetail(id).then(res => {
        if (res.code === 200) {
          this.form = res.data
          this.defaulCheckedKeys.push(this.form.channelId)
          this.$refs.collectTree.setCurrentKey(this.form.channelId)
          this.CollectDetail = deepClone(FastCollectData[this.getIndex(this.form.modelType)])
        }
      })
    },
    // 设置栏目
    getCmsData () {
      this.$request.getClientData({ 'id': this.id, 'appid': this.appid }).then(res => {
        this.channelLoading = false
        if (res.code === 200) {
          this.ChannelList = res.data.channels
          this.channelModels = res.data.channelModels
          if(this.$route.query.taskId !== undefined) {
            console.log('编辑this.form', this.form);
            this.ModelOptions = this.channelModels[this.form.channelId]
          }else {
            console.log('新建');
            this.ModelOptions = []
          }
          // 内容模型初始化
          // this.form.modelId = Number(getTreeIds(res.data.models, this.ModelOptions[0].id))
          // console.log(Number(getTreeIds(res.data.models, this.ModelOptions[0].id)), 'sadasdasda', this.ModelOptions)
        }
      })
    },
    // 初始化
    initConfing () {
      // 字段初始化
      this.form.fieldIds = this.CollectDetail.tableTile.map((t) => {
        return t.fieldIds
      })
    },
    // 获取栏目ID
    handleNodeClick (data) {
      console.log(data,'data');
      this.form.channelId = ''
      this.form.modelId = ''
      if (data.isBottom) {
        this.form.channelId = data.id
        this.ModelOptions =  this.channelModels[data.id]
      }
    },
    // 查看任务/ 开始采集
    startCollectTasks () {
      if(!this.form.channelId) {
        this.$message.error('请选择底层栏目')
        return false
      }
      let obj = Object.assign({ appId: this.appid }, this.form)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$request.fetchCollectUpdate(obj).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.goTo('FastCollectLog', { taskId: res.data })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 立即开始
    playCollect () {
      if(!this.form.channelId) {
        this.$message.error('请选择底层栏目')
        return false
      }
      let obj = Object.assign({ appId: this.appid, modelType: this.CollectDetail.modelType }, this.form)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$request.fetchCollectStart(obj).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.goTo('FastCollectLog', { taskId: res.data })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 保存任务
    save () {
      if(!this.form.channelId) {
        this.$message.error('请选择底层栏目')
        return false
      }
      let obj = Object.assign({ appId: this.appid, modelType: this.CollectDetail.modelType }, this.form)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$request.fetchCollectTaskCreate(obj).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '保存成功',
                onClose: () => {
                  this.goHome()
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改任务
    edit () {
      if(!this.form.channelId) {
        this.$message.error('请选择底层栏目')
        return false
      }
      let obj = Object.assign({ appId: this.appid, modelType: this.CollectDetail.modelType }, this.form)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$request.fetchCollectTaskUpdate(obj).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '保存成功',
                onClose: () => {
                  this.goHome()
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    goTo (name, query) {
      query = query || {}
      this.$router.push({ name: name, query: query })
    },
    goHome () {
      this.$refs['form'].resetFields()
      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style lang="scss">
.fast-collect-config-container{
  .fast-collect-config-back{
    margin-bottom: 20px;
    .el-button{
      font-size:16px;
      width: 90px;
      padding: 9px 0;
    }
    .jee-svg-icon{
      vertical-align: -0.1em;
      font-size: 14px;
    }
  }

  .fast-collect-config-box{
    h2{
      font-size:18px;
      font-weight:normal;
      color:rgba(51,51,51,1);
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(232,232,232,1);
      margin-bottom: 30px;
    }
    .fast-collect-config-form{
      width: 650px;
      .el-form-item{
        .el-form-item__label{
          font-size:14px;
          color:rgba(102,102,102,1);
        }
        .el-checkbox{
          display: inline-block;
        }
        .el-tree-node.is-current > .el-tree-node__content {
          background-color: #F0F0F0 !important;
          color: #1EC6DF;
        }
        .el-tree {
          border:1px solid rgba(232,232,232,1);
          border-radius:4px;
          padding: 10px 0;
          .el-tree-node__content{
            height: 32px;
          }
        }
        .el-button {
          height: 32px;
          padding: 0 20px;
        }
      }
      .fast-collect-config-form-checkbox{
        /deep/ .el-form-item__label{
          line-height: 20px;
        }
        /deep/ .el-form-item__content{
          line-height: 20px;
        }
      }
      .fast-collect-config-form-tip{
        margin-top:9px;
        font-size:12px;
        font-weight:normal;
        color:rgba(153,153,153,1);
        line-height:18px;
      }
    }
  }
}
</style>
